import { get, writable } from 'svelte/store';
import { navigate } from '../../app.logic';
import { ActivityService } from '../../services/activity.service';
import '../../utils/CustomFieldEntities/custom-field-utils';
export const loading = writable(false);
export const filter = writable({ criteria: {} });
export const records = writable([]);
export const pagination = writable(null);
export const record = writable(null);
export const stats = writable(null);
export const tableCustomFields = writable([]);
let entityId;
let entityType;
export async function initList(entId, entType) {
    entityId = entId;
    entityType = entType;
    filter.set({ criteria: { entityId: entityId, entityType: entityType }, params: null, sorting: "" });
    pagination.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
    record.set(null);
    await load();
}
export async function initDetail(oid, entityId, type, currentuserid) {
    record.set(null);
    stats.set(null);
    if (oid == 0) {
        let ac = {
            oid: 0,
            commentText: '',
            clfState: null,
            expireDate: null,
            assignedTo: null,
            noteOnCompletition: '',
            doneDate: null,
            subject: '',
            createdBy: currentuserid,
            updatedBy: currentuserid,
            createdOn: new Date(),
            updatedOn: new Date()
        };
        let tmpRecord = { oid: 0, entityId: entityId, entityType: type, activity: ac };
        record.set(tmpRecord);
    }
    else {
        let _resp = await ActivityService.fetchActivity(oid, type).toPromise();
        record.set(_resp.payload);
    }
}
export async function search() {
    pagination.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
    await load();
}
export async function clearSearch() {
    resetSearchFilter();
    search();
}
export function resetSearchFilter() {
    filter.set({ criteria: { entityId: entityId, entityType: entityType }, params: null, sorting: "" });
}
export async function load() {
    loading.set(true);
    try {
        let _filter = get(filter);
        let _pag = get(pagination);
        let _resp = await ActivityService.getActivities(_filter, _pag.currentPage).toPromise();
        records.set(_resp.payload);
        pagination.set(_resp.pagination);
    }
    finally {
        loading.set(false);
    }
}
export function onCreate() {
    navigate(`/task/0/${entityType}`);
}
export function onEdit(item) {
    navigate(`/task/${item.oid}/${item.entityType}`);
}
export async function save() {
    let _record = get(record);
    return ActivityService.saveActivity(_record).toPromise();
}
export async function onDelete(item) {
    await ActivityService.deleteActivity(item.oid).toPromise();
    await load();
}
export function onPageChange(pageNumber) {
    pagination.set(Object.assign(Object.assign({}, get(pagination)), { currentPage: pageNumber }));
    load();
}
